import * as angular from "angular";
import * as _ from "lodash";
import {SiteFiltersType} from "../../commons/types/site-filters.type";
import {escapeForJsonSearch} from "../../commons/utils/json-search-escape.util";

export interface PlanningResourcesFilterContext {
  filterConfig: any;
}

export class PlanningResourcesHelperService {

  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;

  /* @ngInject */
  constructor(private $timeout: any) {}

  public initFilters(panel: any) {
    if (!panel.tabsFilterConfig) {
      panel.tabsFilterConfig = {};
    }
    if (!panel.tabsFilterConfig[panel.selectedTabIndex]) {
      panel.tabsFilterConfig[panel.selectedTabIndex] = {};
    }
    if (!panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.branchIds]) {
      panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.branchIds] = [];
    }
    if (!panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.serviceAreaIds]) {
      panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.serviceAreaIds] = [];
    }
    if (!panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.vehicleTypes]) {
      panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.vehicleTypes] = [];
    }
    if (!panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.agentSkills]) {
      panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.agentSkills] = [];
    }
    if (!panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.labels]) {
      panel.tabsFilterConfig[panel.selectedTabIndex][this.siteFiltersType.labels] = [];
    }
    if (!panel.tabsFilterConfig[panel.selectedTabIndex].resourceIds) {
      panel.tabsFilterConfig[panel.selectedTabIndex].resourceIds = [];
    }
  }

  public filterByFilters(resource: any, ctx: PlanningResourcesFilterContext): boolean {
    if (!ctx || !ctx.filterConfig) {
      return true;
    }
    const shouldReturnByQuery = this.filterByQuery(resource, ctx.filterConfig);
    const shouldReturnBySkill = this.filterBySkills(resource, ctx.filterConfig);
    const shouldReturnByAreaIds = this.filterByAreaIds(resource, ctx.filterConfig);
    const shouldReturnByInRoute = this.filterByInRoute(resource, ctx.filterConfig);
    const shouldReturnByBranchIds = this.filterByBranchIds(resource, ctx.filterConfig);
    const shouldReturnByLabels = this.filterByLabels(resource, ctx.filterConfig);
    const shouldReturnByVehicleTypes = this.filterByVehicleTypes(resource, ctx.filterConfig);

    return shouldReturnBySkill && shouldReturnByAreaIds && shouldReturnByInRoute && shouldReturnByQuery && shouldReturnByBranchIds && shouldReturnByLabels && shouldReturnByVehicleTypes;
  }

  public filterByQuery(resource: any, filterConfig: any): boolean {
    return !filterConfig.queryString ? true : _.includes(JSON.stringify(resource), escapeForJsonSearch(filterConfig.queryString));
  }

  public filterBySkills(resource: any, filterConfig: any): boolean {
    const skills = filterConfig[this.siteFiltersType.agentSkills];
    return !_.get(skills, 'length') || _.filter(resource.allocationSkills, (skill) => {
      return _.includes(skills, skill);
    }).length > 0;
  }

  public filterByAreaIds(resource: any, filterConfig: any): boolean {
    const areaIds = filterConfig[this.siteFiltersType.serviceAreaIds];
    return !_.get(areaIds, 'length') || _.filter(resource.areaIds, (aid) => {
      return _.includes(areaIds, aid);
    }).length > 0;
  }

  public filterByBranchIds(resource: any, filterConfig: any): boolean {
    const branchIds = filterConfig[this.siteFiltersType.branchIds];
    return !_.get(branchIds, 'length') || _.filter(resource.branchIds, (aid) => {
      return _.includes(branchIds, aid);
    }).length > 0;
  }

  public filterByVehicleTypes(resource: any, filterConfig: any): boolean {
    const vehicleTypes = filterConfig[this.siteFiltersType.vehicleTypes];
    return !_.get(vehicleTypes, 'length') || _.includes(vehicleTypes, resource.vehicleClass);
  }

  public filterByLabels(resource: any, filterConfig: any): boolean {
    const labels = filterConfig[this.siteFiltersType.labels];
    return !_.get(labels, 'length') || _.filter(resource.labels, (aid) => {
      return _.includes(labels, aid);
    }).length > 0;
  }

  public filterByInRoute(resource: any, filterConfig: any): boolean {
    const inRoute = filterConfig[this.siteFiltersType.inRoute];
    return _.isUndefined(inRoute) || _.isEqual(resource.routed, inRoute);
  }

  public sortFilteredResources(filteredResources: any[], sortBy: string, sortByType: 'asc' | 'desc'): any[] {
    let filteredResourcesCopy = angular.copy(filteredResources);
    if (sortBy === 'tags') {
      return _.orderBy(filteredResourcesCopy, [(r) => !!r.tags?.length, (r) => _.toLower(r.tags?.[0])], [sortByType, sortByType]);
    }
    return _.orderBy(filteredResourcesCopy, [sortBy], [sortByType]);
  }

  public setRoutesMap(routes: any[]): any {
    const routesMap = {};
    _.forEach(routes, (r) => {
      if (!routesMap[r.resourceId]) {
        routesMap[r.resourceId] = [];
      }
      routesMap[r.resourceId].push(r);
    });
    return routesMap;
  }

  public getEnrichedResources(resources: any[], routesMap: any): any[] {
    return (resources || []).map(resource => {
      let resourceCopy = angular.copy(resource);
      resourceCopy.routesCount = routesMap[resource.id]?.length || 0;
      return resourceCopy;
    });
  }
}

angular
  .module('bringoz.admin.planning')
  .service('planningResourcesHelperService', PlanningResourcesHelperService);
